/**
 * bundle-picker.js
 * Vervangt de Kaching Bundles app (158 KB -> ~5 KB).
 *
 * Wat dit bestand doet:
 *   - de gekozen staffel bijhouden
 *   - per stuk een variant laten kiezen (mix & match)
 *   - bij "toevoegen aan winkelwagen" alle gekozen varianten in één keer toevoegen
 *
 * Wat dit bestand NIET doet: korting rekenen. Dat doen je automatische
 * Shopify-kortingen (15% vanaf 2, 20% vanaf 3, 25% vanaf 4 stuks). Deze kiezer
 * zorgt alleen dat de juiste aantallen in het mandje komen.
 *
 * Toegevoegd 1 aug 2026
 */
(function () {
  'use strict';

  var ROUTES = (window.theme && window.theme.routes) || {};
  var CART_ADD = ROUTES.cartAdd || '/cart/add.js';

  function init(picker) {
    if (picker.__bundleInit) return;
    picker.__bundleInit = true;

    var varianten = [];
    try {
      varianten = JSON.parse(picker.querySelector('[data-bundle-varianten-json]').textContent);
    } catch (e) {
      console.error('[bundelkiezer] kon varianten niet lezen', e);
      return;
    }

    var opties = picker.querySelectorAll('[data-bundle-optie]');
    var blokken = picker.querySelectorAll('[data-bundle-varianten]');

    /* Toont de variantkiezers van de gekozen staffel, verbergt de rest. */
    function toonGekozen() {
      var gekozenQty = 1;
      Array.prototype.forEach.call(opties, function (optie) {
        var radio = optie.querySelector('[data-bundle-radio]');
        var actief = radio && radio.checked;
        optie.classList.toggle('is-gekozen', !!actief);
        if (actief) gekozenQty = parseInt(optie.getAttribute('data-qty'), 10) || 1;
      });
      Array.prototype.forEach.call(blokken, function (blok) {
        blok.hidden = parseInt(blok.getAttribute('data-qty'), 10) !== gekozenQty;
      });
      picker.setAttribute('data-gekozen-qty', gekozenQty);
    }

    /* Zet het miniatuurtje op de foto van de gekozen variant. */
    function ververThumbs() {
      var rijen = picker.querySelectorAll('[data-bundle-item]');
      Array.prototype.forEach.call(rijen, function (rij) {
        var selects = rij.querySelectorAll('[data-bundle-optie-naam]');
        var waarden = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = zoekVariant(waarden);
        var img = rij.querySelector('[data-bundle-thumb] img');
        if (!img) return;
        var bron = v && v.featured_image && v.featured_image.src;
        if (bron) {
          img.src = bron.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
        }
      });
    }

    picker.addEventListener('change', function (e) {
      if (e.target.matches('[data-bundle-radio]')) { toonGekozen(); ververThumbs(); }
      if (e.target.matches('[data-bundle-optie-naam]')) ververThumbs();
    });
    toonGekozen();
    ververThumbs();

    /* Zoekt de variant die bij een combinatie van optiewaarden hoort. */
    function zoekVariant(waarden) {
      for (var i = 0; i < varianten.length; i++) {
        var v = varianten[i];
        var opts = [v.option1, v.option2, v.option3];
        var raak = true;
        for (var j = 0; j < waarden.length; j++) {
          if (opts[j] !== waarden[j]) { raak = false; break; }
        }
        if (raak) return v;
      }
      return null;
    }

    /* Leest alle gekozen varianten uit het zichtbare blok. */
    function gekozenVarianten() {
      var blok = null;
      Array.prototype.forEach.call(blokken, function (b) { if (!b.hidden) blok = b; });
      if (!blok) return null; // staffel van 1 stuk: het theme regelt dit zelf

      var items = blok.querySelectorAll('[data-bundle-item]');
      var resultaat = [];
      for (var i = 0; i < items.length; i++) {
        var selects = items[i].querySelectorAll('[data-bundle-optie-naam]');
        var waarden = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = zoekVariant(waarden);
        if (!v) return { fout: 'That combination isn’t available: ' + waarden.join(' / ') };
        if (v.available === false) return { fout: 'Sold out: ' + waarden.join(' / ') };
        resultaat.push({ id: v.id, quantity: 1 });
      }
      return { items: resultaat };
    }

    /* ------------------------------------------------------------------
       Meldingen aan de klant

       Hier stond een kale alert() met de foutmelding van JavaScript erin.
       Een tester kreeg daardoor letterlijk dit voor zijn neus:

           Unexpected token '<', "<!DOCTYPE "... is not valid JSON

       Dat gebeurt als /cart/add.js geen winkelwagen teruggeeft maar een
       HTML-pagina - de botcontrole van Shopify (HTTP 429, "Verifying your
       connection..."). Voor een bezoeker is dat onbegrijpelijk en het ziet
       eruit alsof de winkel stuk is.

       Nu verschijnt er een nette regel onder de bundelkiezer, in het Engels
       net als de rest van de winkel, met een uitleg die klopt bij wat er
       werkelijk aan de hand is.
       ------------------------------------------------------------------ */
    var meldingEl = null;

    function toonMelding(tekst) {
      if (!meldingEl) {
        meldingEl = document.createElement('p');
        meldingEl.className = 'bundelkiezer__melding';
        meldingEl.setAttribute('role', 'alert');
        picker.appendChild(meldingEl);
      }
      meldingEl.textContent = tekst;
      meldingEl.hidden = false;
    }

    function verbergMelding() {
      if (meldingEl) meldingEl.hidden = true;
    }

    /* Vertaalt een technische fout naar iets waar een klant iets aan heeft. */
    function leesbareFout(err) {
      var m = (err && err.message) || '';
      if (err && err.teDruk) {
        return 'We’re a little busy right now. Please try again in a few seconds.';
      }
      if (/JSON|DOCTYPE|Unexpected token/i.test(m)) {
        return 'We’re a little busy right now. Please try again in a few seconds.';
      }
      if (/NetworkError|Failed to fetch|network/i.test(m)) {
        return 'Connection lost. Please check your internet and try again.';
      }
      return m || 'Something went wrong while adding to your cart. Please try again.';
    }

    /* Onderschept de toevoegen-knop zodra er meer dan 1 stuk gekozen is. */
    var form = picker.closest('form') ||
               document.querySelector('form.product-single__form') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    /*
      Let op: we luisteren op document in de CAPTURE-fase, niet op het formulier
      zelf. Het theme heeft namelijk zijn eigen submit-handler op datzelfde
      formulier die het gekozen product toevoegt. preventDefault() stopt alleen
      het standaardgedrag van de browser, niet die tweede handler - daardoor
      kwamen er bij 2 stuks 3 producten in het mandje (2 van ons + 1 van het
      theme). Capture op een voorouder draait vóór alle handlers op het
      formulier, zodat stopPropagation() die van het theme tegenhoudt.
    */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;

      var qty = parseInt(picker.getAttribute('data-gekozen-qty'), 10) || 1;
      if (qty <= 1) return; // 1 stuk: laat het theme zijn werk doen

      var keuze = gekozenVarianten();
      if (!keuze) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (keuze.fout) {
        toonMelding(keuze.fout);
        return;
      }

      verbergMelding();

      var knop = form.querySelector('[name="add"]');
      if (knop) knop.setAttribute('disabled', 'disabled');

      fetch(CART_ADD, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: keuze.items })
      })
        .then(function (r) {
          /*
            Eerst als tekst lezen. Krijgen we de botcontrole van Shopify, dan
            is dit HTML en zou r.json() een onleesbare fout opleveren die
            rechtstreeks bij de klant terechtkwam.
          */
          if (r.status === 429) {
            var teDruk = new Error('te veel verzoeken');
            teDruk.teDruk = true;
            throw teDruk;
          }
          return r.text().then(function (tekst) {
            try {
              return JSON.parse(tekst);
            } catch (e) {
              var fout = new Error('geen geldig antwoord');
              fout.teDruk = true;
              throw fout;
            }
          });
        })
        .then(function (res) {
          if (res && res.status && res.status !== 200) {
            throw new Error(res.description || res.message || 'Adding to cart failed.');
          }
          // Laat het theme de cart bijwerken en de drawer openen
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (err) {
          console.error('[bundelkiezer]', err);
          toonMelding(leesbareFout(err));
        })
        .then(function () {
          if (knop) knop.removeAttribute('disabled');
        });
    }, true);
  }

  function start() {
    document.querySelectorAll('[data-bundle-picker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Voor de theme-editor
  document.addEventListener('shopify:section:load', start);
})();
